import { render } from "./Imprint.html?vue&type=template&id=3e7c8500&scoped=true&ts=true&external"
import script from "./Imprint.ts?vue&type=script&lang=ts&external"
export * from "./Imprint.ts?vue&type=script&lang=ts&external"

import "./Imprint.css?vue&type=style&index=0&id=3e7c8500&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7c8500"]])

export default __exports__